import styled from 'styled-components';
import { ColorAddiBackgroundSoft, ColorAddiBlack, ColorAddiFeedbackInfo, ColorAddiFontError, ColorAddiFontSuccess, ColorAddiGrayLighten1, ColorAddiGrayLighten3, ColorAddiWhite, } from '@addi/foundation/dist/web/colors';
import { FontAddiFamilySecondaryName } from '@addi/foundation/dist/web/fonts';
export const GridBadge = styled.div `
  display: grid;
  padding: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  grid-gap: 10px;
  margin-bottom: 20px;
`;
export const BlankSpace = styled.div `
  padding: 1rem;
`;
export const Badge = styled.span `
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 4px;
  padding: 10px 16px;
  color: ${ColorAddiGrayLighten1};
  background-color: ${ColorAddiGrayLighten3};
  border: none;
  font-family: ${FontAddiFamilySecondaryName};
`;
/* TODO: Move colors to ui-foundations */
export const BadgeWarning = styled(Badge) `
  background: rgba(255, 251, 214, 1);
  color: rgba(133, 99, 7, 1);
`;
export const BadgeInfo = styled(Badge) `
  background: ${ColorAddiFeedbackInfo};
  color: ${ColorAddiWhite};
`;
export const BadgeSuccess = styled(Badge) `
  background: rgba(212, 252, 231, 1);
  color: ${ColorAddiFontSuccess};
`;
export const BadgeDanger = styled(Badge) `
  background: rgba(255, 211, 209, 1);
  color: ${ColorAddiFontError};
`;
export const BadgeLight = styled(Badge) `
  background: ${ColorAddiBackgroundSoft};
  color: ${ColorAddiBlack};
`;
export const BadgeDark = styled(Badge) `
  background: ${ColorAddiBlack};
  color: ${ColorAddiWhite};
`;
//# sourceMappingURL=badges.styled.js.map